import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-underlined",
  "use": "format-underlined-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-underlined\"><path fill-rule=\"evenodd\" d=\"M18 11V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6s6-2.69 6-6ZM5 21h14v-2H5v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol